/* /rules — single-page hub. Renders RulesHub with the Watching tab
 * by default. The Library and Drawings tabs share the same URL via
 * `?tab=library|drawings`. See `components/rules/RulesHub.tsx`. */

import { RulesHub } from "../components/rules/RulesHub";

export default function Rules(): JSX.Element {
  return <RulesHub />;
}
